<template>
  <div>
    <div class="pheadcontainer">
      <span class="phead">Meet the founders</span>
    </div>
    <hr />
    <div class="aboutcontainer">
      <div class="foundercontainer">
        <img class="member-image" src="@/assets/founder2.png" width="350px" height="390px"/>
        <p class="desc" style="text-align: center">
          Preksha is an 11th grade student studying at Apeejay School<br />
          NOIDA. She likes to read and write.
        </p>
        <p class="desc-mobile" style="text-align: center">
          Preksha is an 11th grade student studying at Apeejay School NOIDA. She
          likes to read and write.
        </p>
      </div>
      <div style="display: flex; align-items: center; font-size: 24px; font-weight:bold; flex-direction: column; justify-content: center;">
        "Life is not a collection of your test papers. It's a story of your activities."
        <p class="unselectable desc" style="color: #171617;">
          Aaryan is an 11th grade student, studying at Apeejay School NOIDA.<br />He
          loves beaches, gaming and mind puzzles.
        </p>
      </div>
      <div class="foundercontainer">
        <img class="member-image" src="@/assets/founder1.png"  width="350px" height="390px"/>
        <p class="desc" style="text-align: center">
          Aaryan is an 11th grade student, studying at Apeejay School NOIDA.<br />He
          loves beaches, gaming and mind puzzles.
        </p>
        <p class="desc-mobile" style="text-align: center">
          Aaryan is an 11th grade student, studying at Apeejay School NOIDA. He
          loves beaches, gaming and mind puzzles.
        </p>
      </div>
    </div>

    <div class="pheadcontainer">
      <span class="phead">Our Team</span>
    </div>
    <hr />
    <div class="member-container">
      <!-- <team-member img="sagar" name="Rushil Koul" desc="Website Head"></team-member> -->
      <team-member img="rushil" name="Rushil Koul" desc="CTO" objfit="object-position:0px 1px"></team-member>
      <team-member img="reya" name="Reya Verma" desc="Creative Head" objfit="object-position:-4px 0px"></team-member>
      <team-member img="saurvi" name="Saurvi Gahlaut" desc="Communications Director"></team-member>
      <team-member img="ananya" name="Ananya Verma" desc="Business Club Head"></team-member>
      <team-member img="ashwin" name="Ashwin Rana" desc="Graphic Designer"></team-member>
      <team-member img="vanessa" name="Vanessa Mukoo" desc="Social Media Manager"></team-member>
      <team-member img="dhaanvi" name="Dhaanvi Singh" desc="Content Writer"></team-member>
      <team-member img="kavya" name="Kavya Khandelwal" desc="Content Writer" objfit="object-position: 0px 0px"></team-member>
    </div>
  </div>
</template>

<script>
import TeamMember from '@/components/TeamMember.vue'
export default {
  components: {
    TeamMember
  },
  mounted() {
    window.scrollTo({top: 0, behavior: "smooth"});
  }
}
</script>



<style scoped>
.desc-mobile {
  display: none;
}

.desc {
  width: 85%;
}

@media screen and (max-width: 950px) {
  .pheadcontainer {
    text-align: center;
  }

  .aboutcontainer {
    flex-direction: column;
    gap: 50px;
  }

  .desc {
    display: none;
  }

  .desc-mobile {
    display: block;
  }
}
</style>

// TEAM MEMBERS
// DHAANVI SINGH - CONTENT WRITER
// KAVYA KHANDELWAL - CONTENT WRITER
// REYA VERMA - CREATIVE HEAD
// RUSHIL KOUL - WEBSITE HEAD
// SHWETA BHAL - COMMUNICATIONS DIRECTOR
// VANESSA MUKOO - SOCIAL MEDIA MANAGER